const BannerClick = (link) => {
    window.location.href = link;
};


function updateHeaderTop() {
  let banner = document.querySelector('.announcement-bar__message');
  if (banner) {
    let bannerHeight = banner.offsetHeight;
    let header = document.querySelector('#shopify-section-header');

    console.log(`${bannerHeight + 20}px`)
    header.style.top = `${bannerHeight + 20}px`;
  }
}

// Initial update on page load
document.addEventListener("DOMContentLoaded", updateHeaderTop);

// Debounced update on page resize
let resizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    updateHeaderTop();
  }, 250); 
});